import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'app-faqs-page',
    templateUrl: './faqs-page.component.html',
    styleUrls: ['./faqs-page.component.scss'],
})
export class FaqsPageComponent implements OnInit {
    merchantFaqs: any[] = []
    clientFaqs: any[] = []

    constructor() {
        this.merchantFaqs.push({
            question: `How can I list my parking on ParkUpp?`,
            answer: `We have built the site to be quite intuitive, please click on “list a parking” on our website and follow the process. Please contact us should you require assistance.`,
        })
        this.merchantFaqs.push({
            question: `How long can I list my parking for?`,
            answer: `ParkUpp Monthly - You can list your parking for a minimum period of one month. Parkers using
            ParkUpp monthly prefer a 6 - 12 month contract.
            <br><br>
            ParkUpp Events - You can list available parking for the day of a specific event.
            <br><br>
            ParkUpp Flex - This allows you to list your parking in a vacant building one month at a time allowing you to end all contracts before your new tenant moves in. Parkers will submit a new parking reservation request one month at a time.
            <br><br>
            ParkUpp Collector  - You can list your parking for a minimum period of one month. Parkers using
            ParkUpp Collector prefer a 6 - 12 month contract.`,
        })
        this.merchantFaqs.push({
            question: `How should I price my listing on ParkUpp?`,
            answer: `We recommend that your parking fee be in line with competing parking in your area. Obviously the cheaper the more likely you are to attract parkers. Please contact us if we can assist.`,
        })
        this.merchantFaqs.push({
            question: `When will I get paid?`,
            answer: `ParkUpp collects parking fees through our Paygate infrastructure and pays to parking owners the received fee less ParkUpps service percentage on the 7th of the following month. Please contact us should require an alternate arrangement.`,
        })
        this.merchantFaqs.push({
            question: `What is ParkUpp’s service fee?`,
            answer: `ParkUpp charges 15% of the parking rental. The ParkUpp fee includes costs associated with payment systems, marketing and administration.
            <br><br>
            Example: if you choose to rent your parking bay out for R800 a month, ParkUpp will charge R120 every month for the duration of the contract. R 680 will be transferred to the property owner by the 7th of the following month, each month, until the contract expires.`,
        })
        this.merchantFaqs.push({
            question: `How can I get further assistance?`,
            answer: `Please reach out to the below:
            <br><br>
            Kwanele Tshabalala - kwanele@parkupp.co.za
            <br>
            Umar Obaray - umar@parkupp.co.za`,
        })

        // Client FAQ's
        this.clientFaqs.push({
            question: `What kind of parking can I find?`,
            answer: `Property owners, whether corporate, listed or private list their available parking bays for rent. Parking facilities include secure office basements ,shopping centres, apartment buildings, private homes and open parking lots.`,
        })
        this.clientFaqs.push({
            question: `How does the booking and payment procedure work?`,
            answer: `When you book for one month or more and after the parking owner confirms your reservation you are charged for the first month rent upfront. You will subsequently be charged on the monthly anniversary of your contract for its duration .
            <br><br>
            Example: Your parking reservation is confirmed for a four month period on the 7th of February by the parking owner. The commencement date is the 15th of March. Your first payment for 15 March - 15 April will be made on the 7th of February, the next payment on 15 April , 15 May etc until the expiration of your requested contract period.`,
        })
        this.clientFaqs.push({
            question: `How can I pay for my parking?`,
            answer: `You can make payment for your parking through our secure payment gateway, Paygate using a credit or debit card or through Snap Scan and Zapper. You may alternatively contact us directly for a special payment arrangement including EFT.`,
        })
        this.clientFaqs.push({
            question: `What if I wish to change my card details?`,
            answer: `Should you wish to change your card details while your contract is in place, please contact us for assistance.`,
        })
        this.clientFaqs.push({
            question: `What happens if my parking reservation is declined or expires?`,
            answer: `In the unlikely event of  your parking request not been accepted by the parking owner within the specified 24 hours, it simply means that there is no contract in place. You will not be charged and you are welcome to book with a different parking owner. Any monies deducted by Paygate in connection with your request will be refunded to your bank account. ParkUpp encourages parking owners to respond to requests in a timely manner.
            <br><br>
            In the instance where your parking contract expires you will be notified by us and encouraged to renew your contract.`,
        })
        this.clientFaqs.push({
            question: `What are ParkUpp’s T’s &C’s?`,
            answer: `ParkUpp’s terms and conditions are clearly stipulated at the bottom of our landing page. We encourage you to read and familiarise yourself with them.`,
        })
        this.clientFaqs.push({
            question: `Can I cancel the booking after the property owner has accepted?`,
            answer: `Submitting a parking request during the booking process constitutes and offer and the acceptance of that request by the owner constitutes an acceptance of that offer . This gives rise to a binding contract between the Parker and the property owner.
            <br><br>
            Parkers are obligated to abide by ParkUpp’s terms and conditions and those of the property owner . This includes timeous payment for the full duration of the parking contract. Failure to do so constitutes a breach of contract. `,
        })
        this.clientFaqs.push({
            question: `How can I renew or extend my parking contract?`,
            answer: `Providing the bay that you are using is still available after the expiry of the initial contract term and provided the owner is willing to lease it out for a new contract period,  you need to complete the process of a new booking. There is no automatic right to renewal. `,
        })
    }

    ngOnInit(): void {}
}
